import script from "./ClientSegmentAnalytics.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientSegmentAnalytics.vue?vue&type=script&setup=true&lang=js"

import "./ClientSegmentAnalytics.vue?vue&type=style&index=0&id=ab59444a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab59444a"]])

export default __exports__